<template>
  <Layout :navbar="false">
    <div class="bg-bridge py-5 flex-grow-1">
      <div class="container py-5">
        <div class="row justify-content-center">
          <div class="col-md-4">
            <InertiaLink
              class="h1 d-block font-weight-light font-family-serif text-center text-white mb-3"
              :href="route('home')"
            >
              Claus.ify
            </InertiaLink>
            <div class="card">
              <div class="card-body p-4">
                <h4 class="mb-4">Reset Password</h4>
                <div v-if="success" class="alert alert-success" role="alert">
                  <small>Check your email for a password reset link.</small>
                </div>
                <form @submit.prevent="submit">
                  <div class="form-group">
                    <TextInput
                      v-model="form.email"
                      :errors="$page.props.errors.email"
                      label="E-Mail Address"
                      type="email"
                      autofocus
                      autocapitalize="off"
                      validateSuccess
                      validateError
                    />
                  </div>

                  <LoadingButton
                    :loading="sending"
                    class="btn btn-block btn-primary btn-rounded"
                    type="submit"
                  >
                    Send Password Reset Link
                  </LoadingButton>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';

export default {
  components: {
    Layout,
    LoadingButton,
    TextInput,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      success: false,
      sending: false,
      form: this.$inertia.form({
        email: null,
      }),
    };
  },
  mounted() {
    document.title = 'Reset Password | Claus.ify';
  },
  methods: {
    submit() {
      this.sending = true;

      this.form.post(this.route('password.email'), {
        preserveScroll: true,
        onSuccess: () => {
          this.sending = false;
          this.success = true;
        },
        onError: () => {
          this.sending = false;
          throw new Error(error);
        },
      });
    },
  },
};
</script>
